<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col sm="12">
          <b-card header-class="redmfu" >
            <div slot="header" v-if="thai_student==1">
              <strong>ตอนที่ 5 ความคิดเห็นและข้อเสนอแนะด้านหลักสูตร</strong>
            </div>
            <div slot="header" v-if="thai_student==0">
              <strong>Part 5 Recommendations for Curriculum </strong>
            </div>
            <div v-for="item in items" v-bind:key="item.QUESTION_PK">
<!--              {{ item.QUESTION_PK }}. {{ item.QUESTION_NAME }}-->
<!--              <div v-if="item.QUESTION_PK==46">-->
<!--                <strong>40.{{ item.QUESTION_NAME }}</strong> {{ selected_46 }}:{{ ans46 }}-->
<!--              </div>-->
              <div v-if="item.QUESTION_PK==47">
                <strong>40.&nbsp; {{ item.QUESTION_NAME }}</strong> {{ selected_47 }}:{{ ans47 }}
              </div>
              <div v-if="item.QUESTION_PK==48">
                <strong>41.&nbsp; {{ item.QUESTION_NAME }}</strong>{{ selected_48 }}:{{ ans48 }}
              </div>
<!--              <div v-if="item.QUESTION_PK==49">-->
<!--                <strong>42.&nbsp; {{ item.QUESTION_NAME }}</strong> {{ selected_49 }}:{{ ans49 }}-->
<!--              </div>-->
<!--              <div v-if="item.QUESTION_PK==50">-->
<!--                <strong>43.&nbsp; {{ item.QUESTION_NAME }}</strong> {{ selected_50 }}:{{ ans50 }}-->
<!--              </div>-->
              <div v-if="item.QUESTION_PK==51">
                <strong>42.&nbsp; {{ item.QUESTION_NAME }}</strong> {{ selected_51 }}:{{ ans51 }}
              </div>
              <div v-if="item.QUESTION_PK==52">
                <strong>43.&nbsp; {{ item.QUESTION_NAME }}</strong> {{ selected_52 }}:{{ ans52 }}
              </div>
              <div v-if="item.QUESTION_PK==53">
                <strong>44.&nbsp; {{ item.QUESTION_NAME }}</strong> {{ selected_53 }}:{{ ans53 }}
              </div>
<!--              <div v-if="item.QUESTION_PK==54">-->
<!--                <strong>47.{{ item.QUESTION_NAME }}</strong> {{ selected_54 }}:{{ ans54 }}-->
<!--              </div>-->
<!--              <div v-if="item.QUESTION_PK==55">-->
<!--                <strong>48.{{ item.QUESTION_NAME }}</strong> {{ selected_55 }}:{{ ans55 }}-->
<!--              </div>-->
              <div v-if="item.QUESTION_PK==54">
                <strong>45.&nbsp; {{ item.QUESTION_NAME }}</strong>
                <p v-if="ans54_1!=''">-{{ ans54_1 }}</p>
                <p v-if="ans54_2!=''">-{{ ans54_2 }}</p>
                <p v-if="ans54_3!=''">-{{ ans54_3 }}</p>
                <p v-if="ans54_4!=''">-{{ ans54_4 }}</p>
                <p v-if="ans54_5!=''">-{{ ans54_5 }}</p>
                <p v-if="ans54_6!=''">-{{ ans54_6 }}</p>
                <p v-if="ans54_9!=''">-{{ ans54_9 }}</p>
                <p v-if="ans54_8!=''">-{{ ans54_8 }}</p>
                <p v-if="ans54_7!=''">-{{ ans54_7 }} {{ qn_addprogram7_txt }}</p>
              </div>
              <p v-if="item.QUESTION_PK ==55"> <strong>46.&nbsp; {{ item.QUESTION_NAME }}</strong><br>{{ current_comment_program }}</p>
              <p v-if="item.QUESTION_PK ==56"> <strong>47.&nbsp; {{ item.QUESTION_NAME }}</strong><br>{{ current_comment_learn }}</p>
              <p v-if="item.QUESTION_PK ==57"> <strong>48.&nbsp; {{ item.QUESTION_NAME }}</strong><br>{{ current_comment_activity }}</p>
              <p v-if="item.QUESTION_PK ==58"> <strong>49.&nbsp; {{ item.QUESTION_NAME }}</strong><br>{{ current_comment_train }}</p>
              <p v-if="item.QUESTION_PK ==59"> <strong>50.&nbsp; {{ item.QUESTION_NAME }}</strong><br>{{ current_comment_inter}}</p>
            </div>
            <div slot="footer" class="text-right" >
              <b-button type="submit" size="md" class="mr-2" variant="success" @click="onBack">
                <i class="fa fa-arrow-circle-o-left"></i> Back
              </b-button>
              <b-button type="submit" size="md" class="mr-2" variant="primary" @click="onNext">
                <i class="fa fa-arrow-circle-o-right"></i> Next
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <table align=center>
<!--    <div slot="footer" class="text-right" >-->
<!--      <b-button type="submit" size="md" class="mr-2" variant="success" @click="onBack">-->
<!--        <i class="fa fa-arrow-circle-o-left"></i> Back-->
<!--      </b-button>-->
<!--      <b-button type="submit" size="md" class="mr-2" variant="primary" @click="onNext">-->
<!--        <i class="fa fa-arrow-circle-o-right"></i> Next-->
<!--      </b-button>-->
<!--    </div>-->
    </table>
  </div>
</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";

export default {
  components: {YimoVueEditor},
  name: "CreateGeneral",
  data() {
    return {
      std_id: "",
      student: {},
      sex: "",
      studentCode: "",
      thai_student: "",
      prefixName: "",
      studentName: "",
      studentSurname: "",
      studentNameEng: "",
      studentSurnameEng: "",
      prefixNameEng: "",
      levelGroupNameEng: "",
      facultyName: "",
      facultyNameEng: "",
      departmentName: "",
      departmentNameEng: "",
      current_erorrtxt: "",
      items: [],
      useritems: [],
      selected_addprogram: "",
      qn_addprogram7_txt: "",
      current_comment_program: "",
      current_comment_learn: "",
      current_comment_activity: "",
      current_comment_train: "",
      current_comment_inter: "",
      selected_addprogram_1: "",
      selected_addprogram_2: "",
      selected_addprogram_3: "",
      selected_addprogram_4: "",
      selected_addprogram_5: "",
      selected_addprogram_6: "",
      selected_addprogram_7: "",
      selected_addprogram_8: "",
      selected_addprogram_9: "",
      // selected_46: "",
      selected_47: "",
      selected_48: "",
      selected_49: "",
      selected_50: "",
      selected_51: "",
      selected_52: "",
      selected_53:"",
      selected_54:"",
      selected_55:"",
      ans46: "",
      ans47: "",
      ans48: "",
      ans49: "",
      ans50: "",
      ans51: "",
      ans52: "",
      ans53: "",
      // ans54: "",
      // ans55: "",
      ans54_1: "",
      ans54_2: "",
      ans54_3: "",
      ans54_4: "",
      ans54_5: "",
      ans54_6: "",
      ans54_7: "",
      ans54_8: "",
      ans54_9: "",
      dangerModal: false,
      actionUpdate: true,
      actionUpdateRegis: true,
      levelid:0,
      lid:0,
    };
  },

  methods: {
    getAns(question, ans, thaistudent) {
      api
        .getSybytedesByAns(question, ans, thaistudent)
        .then(res => {
          var currentSt = res.data.data[0];
          // console.log("question==",question)
          // console.log("length==",res.data.data.length)
          if (res.data.data.length > 0) {
            if (question == "QN_46") {
              this.ans46 = res.data.data[0].BYTEDES;
            }
            if (question == "QN_47") {
              this.ans47 = res.data.data[0].BYTEDES;
            }
            if (question == "QN_48") {
              this.ans48 = res.data.data[0].BYTEDES;
            }
            if (question == "QN_49") {
              this.ans49 = res.data.data[0].BYTEDES;
            }
            if (question == "QN_50") {
              this.ans50 = res.data.data[0].BYTEDES;
            }
            if (question == "QN_51") {
              this.ans51 = res.data.data[0].BYTEDES;
            }
            if (question == "QN_52") {
              this.ans52 = res.data.data[0].BYTEDES;
            }
            if (question == "QN_53") {
              this.ans53 = res.data.data[0].BYTEDES;
            }
            if (question == "QN_54") {
              this.ans54 = res.data.data[0].BYTEDES;
            }
            if (question == "QN_55") {

              this.ans55 = res.data.data[0].BYTEDES;
              // console.log("xxxx=",this.ans55)
            }
            if ((question == 'QN_ADDPROGRAM1')&&
            (ans == 1))
            {
              this.ans54_1 = res.data.data[0].BYTEDES;
            }
            if ((question == 'QN_ADDPROGRAM2')&&(ans == 2)) {
              this.ans54_2 = res.data.data[0].BYTEDES;
            }
            if ((question == 'QN_ADDPROGRAM3')&&(ans == 3)) {
              this.ans54_3 = res.data.data[0].BYTEDES;
            }
            if ((question == 'QN_ADDPROGRAM4')&&(ans == 4)) {
              this.ans54_4 = res.data.data[0].BYTEDES;
            }
            if ((question == 'QN_ADDPROGRAM5')&&(ans == 5)) {
              this.ans54_5 = res.data.data[0].BYTEDES;
            }
            if ((question == 'QN_ADDPROGRAM6')&&(ans == 6)) {
              this.ans54_6 = res.data.data[0].BYTEDES;
            }
            if ((question == 'QN_ADDPROGRAM7')&&(ans == 7)) {
              this.ans54_7 = res.data.data[0].BYTEDES;
            }
            if ((question == 'QN_ADDPROGRAM8')&&(ans == 8)) {
              this.ans54_8 = res.data.data[0].BYTEDES;
            }
            if ((question == 'QN_ADDPROGRAM9')&&(ans == 9)) {
              this.ans54_9 = res.data.data[0].BYTEDES;
            }
          }

          return ans;
        })
        .catch(err => {
          console.log(2);
          console.log("getSybytedesByAns", err.toString());
        });
    },
    getCurrentAnsStudent(studentid) {
      api
        .getQuestionaireStatus(studentid)
        .then(res => {

          if (res.data.data.length > 0) {
            this.current_question1 = res.data.data[0].QUESTIONNAIRE_1;
            this.current_question7 = res.data.data[0].QUESTIONNAIRE_7;
            this.current_graduatestatus = res.data.data[0].GRADUATE_STATUS;
            this.current_poststatus = res.data.data[0].POST_STATUS;
          } else {
            this.current_question1 = 0;
            this.current_question7 = 0;
            this.current_graduatestatus = 0;
          }
          // console.log("current_question1==", this.current_question1);
          // console.log("current_question7==", this.current_question7);
          // console.log("l==", this.levelid)

          // console.log("current_question1=", this.current_question1)
          // console.log("current_question7=", this.current_question7)
        })
        .catch(err => {
          console.log("getCurrentStudent", err.toString());
          this.$router.push("login");
        });
    },
    getCurrentStudent(studentid) {
      api
        .getStudentGeneral(studentid)
        .then(res => {
          // console.log("xxxx==",res);
          var currentSt = res.data.data[0];
          if (res.data.data.length > 0) {
            this.actionUpdate = true;
            this.std_id = this.student.STUDENTID;
            this.thai_student = currentSt.THAI_STUDENT;
            this.selected_47 = currentSt.QN_47;
            this.selected_48 = currentSt.QN_48;
            this.selected_49 = currentSt.QN_49;
            this.selected_50 = currentSt.QN_50;
            this.selected_51 = currentSt.QN_51;
            this.selected_52 = currentSt.QN_52;
            this.selected_53 = currentSt.QN_53;
            // this.selected_54 = currentSt.QN_54;
            // this.selected_55 = currentSt.QN_55;
            this.getAns("QN_47", this.selected_47, this.thai_student);
            this.getAns("QN_48", this.selected_48, this.thai_student);
           /* this.getAns("QN_49", this.selected_49, this.thai_student);
            this.getAns("QN_50", this.selected_50, this.thai_student);*/
            this.getAns("QN_51", this.selected_51, this.thai_student);
            this.getAns("QN_52", this.selected_52, this.thai_student);
            this.getAns("QN_53", this.selected_53, this.thai_student);
            // this.getAns("QN_54", this.selected_54, this.thai_student);
            // this.getAns("QN_55", this.selected_55, this.thai_student);
           if (currentSt.QN_ADDPROGRAM1 == 1) {
              this.getAns("QN_ADDPROGRAM1", 1, this.thai_student);
            }
            if (currentSt.QN_ADDPROGRAM2 == 1) {
              this.getAns("QN_ADDPROGRAM2", 2, this.thai_student);
            }
            if (currentSt.QN_ADDPROGRAM3 == 1) {
              this.getAns("QN_ADDPROGRAM3", 3, this.thai_student);
            }
            if (currentSt.QN_ADDPROGRAM4 == 1) {
              this.getAns("QN_ADDPROGRAM4", 4, this.thai_student);
            }
            if (currentSt.QN_ADDPROGRAM5 == 1) {
              this.getAns("QN_ADDPROGRAM5", 5, this.thai_student);
            }
            if (currentSt.QN_ADDPROGRAM6 == 1) {
              this.getAns("QN_ADDPROGRAM6", 6, this.thai_student);
            }
            if (currentSt.QN_ADDPROGRAM7 == 1) {
              this.getAns("QN_ADDPROGRAM7", 7, this.thai_student);
            }
            if (currentSt.QN_ADDPROGRAM8 == 1) {
              this.getAns("QN_ADDPROGRAM8", 8, this.thai_student);
            }
            if (currentSt.QN_ADDPROGRAM9 == 1) {
              this.getAns("QN_ADDPROGRAM9", 9, this.thai_student);
            }

            this.qn_addprogram7_txt = currentSt.QN_ADDPROGRAM7_TXT;
            this.current_comment_program = currentSt.QN_COMMENT_PROGRAM;
            this.current_comment_learn = currentSt.QN_COMMENT_LEARN;
            this.current_comment_activity = currentSt.QN_COMMENT_ACTIVITY;
            this.current_comment_train = currentSt.QN_COMMENT_TRAIN;
            this.current_comment_inter = currentSt.QN_COMMENT_INTERNATIONALSATION;
          } else {
            this.actionUpdate = false;
          }
        })
        .catch(err => {
          console.log("getCurrentStudent", err.toString());
          this.actionUpdate = false;
          this.$router.push("login");
        });
    },
    getQuestion: function (section, sex, thaistudent) {
      api
        .getQuestionBySection(section, sex, thaistudent)
        .then(res => {
          this.items = res.data.data;
          // console.log(this.items);
        })
        .catch(err => {
          console.log("2 getQuestionBySection", err.toString());
        });
    },
    getStudentQuestion() {
      this.std_id = this.$store.state.user.studentid;
      this.stdstudentId = this.$store.state.user.studentid;
      this.thai_student = this.$store.state.user.thaistudent;
      this.sex = this.$store.state.user.sex;
      this.getQuestion(5, this.sex, this.thai_student);
    },
    nextPart() {
      // if( this.actionUpdate == false){
      //     this.$router.push("/General");
      //   }else{

      // this.$router.push("/Q3r7c");
      // }
    },
   /* updatePart5() {
      api
        .updateStudentPart5(this.student)
        .then(res => {
          // console.log(res);
          this.message = res.message;
          // console.log("update ผ่าน", this.std_id);
        })
        .catch(err => {
          console.log("updatePart5 error", err.toString());
        });
    },*/
    onBack() {
      this.$router.push("employment4");
    },
    getStudentLevel(){
      this.lid = this.$store.state.user.levelid
      if (this.lid > 10) {
        var num_divide = 0;
        if (this.lid < 99) {
          num_divide = 10;
        } else {
          num_divide = 100;
        }
        // console.log("==", num_divide)
        this.levelid = Math.floor(this.lid / num_divide)
      } else {
        this.levelid = this.lid;
      }
    },
    onNext() {
      this.$router.push("/main");
      // console.log("current_question1==", this.current_question1);
      // console.log("current_question7==", this.current_question7);
    /*  this.getStudentLevel();
     // console.log("levelid==", this.levelid);
      if (this.levelid == 3) { // ปอตรี
         if ((this.current_question1 == 1) && (this.current_question7 == 1)) {
           this.$router.push("/main");
         } else if ((this.current_question1 == 1) && (this.current_question7 != 1)) {
           this.$router.push("/part10");
         } else if ((this.current_question1 == 0) && (this.current_question7 != 1)) {
           this.$router.push("/general");
         }else{
           this.$router.push("/general");
         }
       } else {
         if (this.current_question1 == 1) {
           this.$router.push("/main");
         } else {
           this.$router.push("/general");
         }
       }*/
      // this.$router.push("Dashboard");
    },
    getCurrentUserQuestion(studentid) {
      api
        .getStudentUserQuestionById(studentid)
        .then(res => {
          if (res.data.data.length > 0) {
            // console.log("res==", res);
            // console.log(
            //   "this.actionUpdateRegis มี regis แล้ว",
            //   this.actionUpdateRegis
            // );
            this.actionUpdateRegis = true;
          } else {
            this.actionUpdateRegis = false;
            // console.log(
            //   "this.actionUpdateRegis ไม่มี regis",
            //   this.actionUpdateRegis
            // );
          }
        })
        .catch(err => {
          this.actionUpdateRegis = false;
          console.log("getStudentUserQuestionById error", err.toString());
        });
    }
  },
  mounted() {
  },
  created() {
    if (this.$store.state.token == null || this.$store.state.user == null) {
      this.$router.push("/login");
    } else {
      // this.$router.push("/dashboard");
    }
    this.std_id = this.$store.state.user.studentid;
    this.actionUpdate = this.getCurrentStudent(this.std_id);
    this.getCurrentAnsStudent(this.std_id);
    // console.log("current_question1==", this.current_question1);
    // console.log("current_question7==", this.current_question7);
    api.onSetHeader();
    this.getStudentQuestion();
    this.getCurrentUserQuestion(this.std_id);

  }
};
</script>
<style>
</style>
